module.exports = __webpack_public_path__ + "static/media/star_fill.45dd5470.png";